appSocial.service('SocialUser', ['Trader', function (Trader) {
    /**
     * @extends {Trader}
     * @name SocialUser
     * @class
     */
    class SocialUser extends Trader {
        /**
         * @param {string} token
         * @param {string} traderId
         */
        login(token, traderId) {
            this.token = token;
            this.id = traderId;
            this.loggedIn = true;
        }

    }

    return SocialUser;
}])
